// removed by extract-text-webpack-plugin
module.exports = {"root":"_28ZdX","header":"_OOROn","closeIcon":"_wfpND","title":"_30Adn","descriptionList":"_39dL-","listItem":"_3HdyV","check":"_18TVn","content":"_JZyQr","body":"_3khJH"};


//////////////////
// WEBPACK FOOTER
// ./app/components/LearnMoreModal/LearnMoreModal.scss
// module id = 1515
// module chunks = 1